// extracted by mini-css-extract-plugin
export default {"container":"Statistics_container__6IE6h","label":"Statistics_label__y8VBd","valueBox":"Statistics_valueBox__3Z+fd","icon":"Statistics_icon__o2n8C","value":"Statistics_value__Yv1Tg"};